<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import mxdj from "./mxdj/index.vue";
import uploadFile from "../../../common/uploadFile/index.vue";
import {landinit,landquery,dateclear,listexport,detailimport} from '../../../../api/cztds.js'
	import config from '../../../../../configHttp.js'
export default {
   name: "cztdsys",
  components: {
    mxdj,
    uploadFile,
  },
  data: function () {
    return {
		//主页查询
      tablekey: 0,
      overlength: 0,
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [{}],
      shaidiag: false,
      searchdiag: false,
	  //
      showmxdj: false,
      hzdiag: false,
      diagData: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      czData: [{}, {}, {}],
      fcData: [{}, {}, {}],
      uploaddiag: false,
	  mxsearch:{},
	  outlistx:{},
	  tabjson:getdata().tabjson,
	  filetype:'',
	  filepu:null,
	  suosq: this.$getdefultMonth(),
    };
  },
  created() {
	  this.init();
  },
  mounted() {
  },
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
	  getJxzcInfo(){
		  this.init();
	  },
	  fordownloadmb(){
			let params = {
        downUrl: config.baseURL + "land/dowloadTemplate",
        typeObj: {
          toForm: true,
          fileType:'xlsx',
					failUrl:this.$winURl
        },
        params: {
          type: this.filetype,
        },
      };
      this.$downloadcommon(params);
	  },
	  getuploadparams(e){
	  		  this.filepu = e
	  },
	  nextsc(){
		  if(this.filetype==''){
			  this.$message.error('请选择明细类型')
		  }else{
			  const formData = new FormData();
			  formData.append('file',this.filepu.upfile);
			  formData.append('detailType',this.filetype);
			  formData.append('importType','0');
			  detailimport(formData).then(res=>{
          if(res.data.code==1){
            if (res.data.data.errorCount > 0) {
              this.fordowloaderr(this.filepu.filetype , res.data.data.batchNo);
            } else {
              this.$message.success("上传成功");
            }
            this.landquery();
			  		this.uploaddiag= false
			  	}else{
			  		this.$message.error(res.data.msg)
			  	}
			  })
		  }
	  },
    fordowloaderr(filetype, batchNo) {
      let params = {
        downUrl: config.baseURL + "/upload-history/downloadErrorFile",
        typeObj: {
          toForm: true,
          fileType:filetype,
					failUrl:this.$winURl
        },
        params: {
          batchNo: batchNo,
        },
      };
      this.$downloadcommon(params);
    },
	  dc() {
	  	let out = this.$refs.tablebox.getSelectionval()
	  	let paramsx = []
	  	out.map(item => {
	  		paramsx.push(item.id)
	  	})
	  	let params = {
	  		downUrl: config.baseURL + "/land/list/export",
	  		typeObj: {
	  			toForm: false,
	  			fileType: 'xlsx',
	  			fileName: "城镇土地使用税" + this.$timestampToStr(new Date(), "yyyyMMdd"),
	  		},
	  		params: {
	  			pageShowListPojo: {
	  				...this.searchdata,
	  			},
	  			ids:paramsx,
	  			json: this.tabjson
	  		}
	  	}
	  	this.$downloadcommon(params)
	  },
	  //初始化
	  init() {
	  	landinit().then((res) => {
	  		if (res.data.code == 1) {
          // this.searchdata.suosq= res.data.data.suosq;
				  this.mxsearch = res.data.data
	  			this.landquery();
	  		} else {
	  			this.$message.error(res.data.msg);
	  		}
	  	});
	  },
	  landquery(){
		  let params = JSON.parse(JSON.stringify(this.searchdata));
		  params.current = this.pagination.pageNum;
		  params.size = this.pagination.pageSize;
		  params.sort = "";
		  params.order = "";
		  params.suosq = this.suosq
		  landquery(params).then((res) => {
		  	if (res.data.code == 0) {
		  		this.$message.error(res.data.msg);
		  		return;
		  	} else {
		  		this.tableData = res.data.data.records;
				this.pagination.total = res.data.data.total;
				this.jinyongpd()
		  	}
		  });
	  },
	  
	  jinyongpd() {
	    this.tableData.forEach((res) => {
	      res.sfydata = res.ybtsehj ? true : false; //是否有转出数据
	      res.sfyshenbao = res.suosqbz == "1" ? true : false; //是否是当前申报期
	    });
	  },
	  deletex(e){
		  if(e.sfydata){
			  this.$showConfirm({
			  message:'清空数据后当前税款所属期间内的所有数据将清除，是否确认操作？'
			  }).then(res => {
				  let params = {
				  				  id:e.id,
				  				  suosq : this.suosq
				  }
				  dateclear(params).then(res=>{
				  	 if(res.data.code==1){
				  		this.landquery()
				  	}else{
				  					this.$message.error(res.data.msg)
				  	}
				  })
			  })
			 
		  }
		 
	  },
	  showdj(e){
		  if(e.suosqbz==2){
			  return 
		  }else{
			  this.outlistx.id = e.id
			  this.outlistx.shenbzq = e.shenbzq
			  this.outlistx.nsrsbh = e.nsrsbh
			  this.outlistx.suosq = this.suosq
			  this.outlistx.lflszc = e.lflszc
			  this.outlistx.companyNo = e.companyNo
			  this.showmxdj=true
		  }
		 
	  },
	  sizechange(e) {
	    this.pagination.pageSize = e;
	    this.landquery()
	  },
	  currentChange(e) {
	    this.pagination.pageNum = e;
	    this.landquery()
	  },
	  submitSearch() {
	    this.pagination.pageNum = 1;
	    this.pagination.paginationkey++;
	    this.landquery()
	  },
	  //
    forback(e) {
	  this.init()
      this.showmxdj = false;
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
